module.exports = __webpack_public_path__ + "static/the-fifth-risk-6753f5d884f482582049a27fc2a68887.jpg";